import React from 'react';
import styles from './Header.module.css';
import Toolbar from '../Toolbar/Toolbar';

const Header = ({
    logo,
    title,
    subtitle,
    navItems = [],
    actions = [],
    toolbarTools = [],
    activeTool,
    onToolChange,
    user,
    onLogoClick,
    onNavClick,
    onUserClick,
    sticky = false,
    className = ''
}) => {
    return (
        <header
            className={`${styles.header} ${sticky ? styles.sticky : ''} ${className}`}
            role="banner"
        >
            <div className={styles.container}>
                {/* Логотип и заголовок */}
                <div className={styles.brand} onClick={onLogoClick} style={{ cursor: onLogoClick ? 'pointer' : 'default' }}>
                    {logo && (
                        <div className={styles.logo}>
                            {logo}
                        </div>
                    )}
                    <div className={styles.titleGroup}>
                        {title && <h1 className={styles.title}>{title}</h1>}
                        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    </div>
                </div>

                {/* Навигация */}
                {navItems.length > 0 && (
                    <nav className={styles.nav} role="navigation" aria-label="Основная навигация">
                        {navItems.map((item) => (
                            <a
                                key={item.id}
                                href={item.href}
                                className={`${styles.navItem} ${item.active ? styles.active : ''}`}
                                onClick={(e) => {
                                    if (item.onClick) {
                                        e.preventDefault();
                                        item.onClick();
                                    } else if (onNavClick) {
                                        onNavClick(item);
                                    }
                                }}
                                aria-current={item.active ? 'page' : undefined}
                            >
                                {item.icon && <span className={styles.navIcon}>{item.icon}</span>}
                                <div className={styles.navLabelContainer}>
                                    <span className={styles.navLabel}>{item.label}</span>
                                    {item.sublabel && <span className={styles.navSublabel}>{item.sublabel}</span>}
                                </div>
                            </a>
                        ))}
                        {/* Desktop Toolbar (inline) */}
                        <Toolbar
                            tools={toolbarTools}
                            activeTool={activeTool}
                            onToolChange={onToolChange}
                            className={styles.embeddedToolbar}
                        />
                    </nav>
                )}

                {/* Действия и пользователь */}
                <div className={styles.actions}>
                    {user && (
                        <div
                            className={styles.user}
                            onClick={onUserClick}
                            style={{ cursor: onUserClick ? 'pointer' : 'default' }}
                        >
                            {user.avatar ? (
                                <img src={user.avatar} alt={user.name} className={styles.avatar} />
                            ) : (
                                <div className={styles.avatarPlaceholder}>
                                    {user.name?.charAt(0).toUpperCase()}
                                </div>
                            )}
                            <span className={styles.userName}>{user.name}</span>
                        </div>
                    )}

                    {actions.map((action, index) => (
                        action.component ? (
                            <div key={index} className={styles.actionButton}>
                                {action.component}
                            </div>
                        ) : (
                            <button
                                key={index}
                                className={styles.actionButton}
                                onClick={action.onClick}
                                disabled={action.disabled}
                                title={action.title}
                                aria-label={action.label}
                            >
                                {action.icon}
                            </button>
                        )
                    ))}
                </div>
            </div>
            {/* Mobile Toolbar (below header) */}
            <div className={styles.mobileToolbarContainer}>
                <Toolbar
                    tools={toolbarTools}
                    activeTool={activeTool}
                    onToolChange={onToolChange}
                    showLabels={true} // Показываем текст на мобильных
                />
            </div>
        </header>
    );
};

export default Header;
